import { useState } from 'react'

import { getAPI } from 'utils/getAPI'

import type {
  ResponseResult,
  ResponseUpdate,
  OrderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRequest,
} from 'api-client'

export const useOrderPlanTransportLot = () => {
  const [isUpdating, setIsUpdating] = useState(false)
  const [result, setResult] = useState<ResponseResult>()
  const [updateResult, setUpdateResult] = useState<ResponseUpdate | undefined>(undefined)

  const fetchOrderPlanTransportLotUpdate = async (body: OrderPlanTransportLotUpdateOrderPlanTransportLotUpdatePostRequest): Promise<ResponseUpdate> => {
    setIsUpdating(true);
    setResult(undefined)
    try {
      const api = await getAPI()
      if (!api) throw new Error('API initialization failed')
      const response = await api.orderPlanTransportLotUpdateOrderPlanTransportLotUpdatePost(body);
      
      setResult(response.result)
      setUpdateResult(response);

      if (response.result.status !== 'success') {
        const error = new Error(response.result.message || '発注計画輸送ロットの更新でエラーが発生しました。');
        Object.assign(error, {
            ...response
        });
        throw error;
      }
      return response;
    } catch (error) {
        if (error && typeof error === 'object' && 'result' in error) {
            const apiResponse = error as ResponseUpdate; 
            await new Promise<void>(resolve => {
              setUpdateResult(apiResponse);
              resolve();
            });
            return await Promise.reject(apiResponse);
        }
        const { response } = error as any;
        const errorResponse = {
            errors: [],
            result: {
                status: 'error',
                message: response && response.status === 422 ? '入力値に誤りがあります。' : `発注計画輸送ロットの更新でエラーが発生しました。`,
                systemDate: null,
                pageNo: 0,
                systemInfo: null,
            },
            updateCount: null,
            lastUpdateDatetime: null,
        };
        await new Promise<void>(resolve => {
          setUpdateResult(errorResponse);
            setResult(errorResponse.result)
            resolve();
        });
        return await Promise.reject(errorResponse);

    } finally {
      setIsUpdating(false);
    }
  };


  return {
    result,
    isUpdating,
    fetchOrderPlanTransportLotUpdate,
    updateResult,
  }
}